










































































































import { AxiosResponse } from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';

import SignInService from '@/api/SigninService';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ProviderButton from '@/components/molecules/ProviderButton/ProviderButton.vue';
import { InitialSuperAdminPath } from '@/constants/routes';
import flagKeys from '@/constants/flagKeys';
import isMobile from '@/utils/mobile-check';
import APIService from '@/api';

import { isOauthSession } from '../../router/router-utils';
import { getSignUpUrl } from '../Onboarding/helpers';
import { treatError } from '@/utils';

interface SubmitEvent extends Event {
  submitter: HTMLElement;
}

@Component({
  components: {
    TextInput,
    FlexButton,
    FilledButton,
    Typography,
    TextField,
    ProviderButton,
    Picture
  },
  $_veeValidate: { validator: 'new' }
})
export default class LoginAdmin extends Vue {
  loading: boolean = false;
  email: string = '';
  password: string = '';
  service: SignInService = new SignInService();

  mounted() {
    this.verifyErrorQuery();
  }

  created() {
    this.getDataFromQuery();
  }

  verifyErrorQuery() {
    const { error } = this.$route.query;

    if (error) {
      if (typeof error === 'string') {
        this.$notification(error, 'error');
      }

      this.$router.replace({ query: {} });
    }
  }

  submit(event: SubmitEvent) {
    event.preventDefault();
    const id = event && event.submitter ? event.submitter.id : '';

    switch (id) {
      case 's-google':
        this.googleSignin();
        break;

      case 's-apple':
        this.appleSignin();
        break;

      default:
        this.emailSignin();
        break;
    }
  }

  async emailSignin() {
    const isValid = await this.$validator.validateAll();
    if (!isValid) return;

    const { email, password } = this;
    const authType = this.isSuperAdmin ? 'super-admin' : 'manager';

    try {
      this.loading = true;
      try {
        const response: any = await this.service.login(
          password,
          email.trim(),
          authType
        );

        const error =
          response &&
          response.response &&
          [400, 401].includes(response.response.status)
            ? (response as { response: AxiosResponse<any> })
            : false;

        if (error && error.response) {
          const message = treatError(error, false);

          throw new Error(message.translation || 'Email or password invalid!');
        }

        if (response.status == 400 || !response.data) {
          throw new Error('Email or password invalid!');
        }

        const { access_token } = response.data;
        this.service.setCredentials(access_token, this.isSuperAdmin && true);

        if (isOauthSession()) {
          this.$router.push({
            name: 'merchant-connect-oauth'
          });
        } else if (this.$route.params.redirect) {
          window.location.assign(this.$route.params.redirect);
        } else {
          if (this.isSuperAdmin) {
            window.location.assign(InitialSuperAdminPath);
          } else {
            const query = this.$route.query as Record<string, any>;
            const host = query.redirect_to || '/';

            delete query.redirect_to;

            const queryParam = new URLSearchParams();

            for (const property in query) {
              queryParam.set(property, query[property]);
            }

            const parsedQueryParam = queryParam.toString();
            const search = parsedQueryParam ? `?${parsedQueryParam}` : '';

            window.location.assign(`${host}${search}`);
          }
        }

        if (this.isSuperAdmin) {
          localStorage.removeItem(
            `${window.location.host}-${APIService.TOKEN_KEY}`
          );
        } else {
          localStorage.removeItem(
            `${window.location.host}-${APIService.SUPER_ADMIN}`
          );
        }
      } catch (e) {
        this.$notification((e as Error).message, 'error');
      }
    } finally {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }

  googleSignin() {
    this.service.loginWithProvider('google', this.$route.params);
  }

  appleSignin() {
    this.service.loginWithProvider('apple', this.$route.params);
  }

  @Watch('email')
  onEmailChange() {
    this.$validator.errors.remove('manager-email');
  }

  @Watch('password')
  onPasswordChange() {
    this.$validator.errors.remove('manager-password');
  }

  goToSignup() {
    this.$router.push({ path: getSignUpUrl() });
  }

  getDataFromQuery() {
    if (this.$route.params.email || this.$route.query.email) {
      this.email = (this.$route.params.email ||
        this.$route.query.email) as string;
    }
  }

  get isMobile() {
    return isMobile();
  }

  get showSignUpLink() {
    return !this.isSuperAdmin;
  }

  get isSuperAdmin() {
    return this.$store.getters['business/isRootView'];
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  verifyFlag(flag: string) {
    return this.getFlags.includes(flag);
  }
}
